/*
 * File: ClampContent.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 14, 2025 at 3:05 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const Wrapper = styled.div`
	-webkit-line-clamp: ${({ $clamp }) => $clamp};
	display: -webkit-box;
    overflow: hidden;
	-webkit-box-orient: vertical;
`;
